import React from 'react';
import logoImg from '../../images/svg/bg-logo--full-anniversary-white.svg';

/**
 * Site header.
 * @returns {React.component} The Header to render.
 */
export default function Header() {
  return (
    <header className="site-header">
      <a href={`${process.env.PUBLIC_URL}/`}>
        <img src={logoImg} alt="The Boston Globe" />
      </a>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js